export default {
  'menu.welcome': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.settings': '個人設置',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',

  // 建銀智能評估系統菜單
  'menu.operations': '運營概況',
  'menu.customer': '客戶管理',
  'menu.customer.customerAdd': '新增客戶',
  'menu.customer.customerEdit': '編輯客戶',
  'menu.task': '任務管理',
  'menu.report': '報告管理',
  'menu.activity': '活動管理',
  'menu.finance': '財務管理',
  'menu.platform': '平台維護',
  'menu.netValueSolution': '淨值方案',
  'menu.ledger': '台賬管理',
  'menu.system': '系統管理',

  // 系統管理子菜單
  'menu.organization': '機構管理',
  'menu.logs': '操作日誌',
  'menu.user': '用戶管理',
  'menu.personal': '個人設置',
  'menu.role': '角色管理',
  'menu.settings': '系統設置',

  // 完整的系統管理子菜單路徑
  'menu.system.organization': '機構管理',
  'menu.system.organizationAdd': '新增機構',
  'menu.system.organizationEdit': '編輯機構',
  'menu.system.organizationView': '機構詳情',
  'menu.system.logs': '操作日誌',
  'menu.system.user': '用戶管理',
  'menu.system.userCreate': '新增用戶',
  'menu.system.userEdit': '編輯用戶',
  'menu.system.personal': '個人設置',
  'menu.system.role': '角色管理',
  'menu.system.roleCreate': '新增角色',
  'menu.system.permission': '權限管理',
  'menu.system.menu': '菜單配置',
  'menu.system.settings': '系統設置',

  // 完整的客戶管理子菜單路徑
  'menu.customer.customerView': '客戶詳情',
  'menu.customer.customerUserCreate': '新增客戶用戶',
  'menu.customer.customerUserEdit': '編輯客戶用戶',

  // 完整的任務管理子菜單路徑
  'menu.task.taskMyTask': '我的任務',
  'menu.task.taskStatistics': '任務統計',
  'menu.task.taskSupplement': '任務信息補充',
  'menu.task.taskSupplementEdit': '編輯任務信息補充',
  'menu.task.taskCreate': '創建任務',
  'menu.task.reportReview': '我的審核',
  'menu.task.reportDetail': '報告詳情',

  // 完整的報告管理子菜單路徑
  'menu.report.reportStatistics': '報告統計',
  'menu.report.reportDetail': '報告詳情',

  // 完整的淨值方案子菜單路徑
  'menu.netValueSolution.netValueSolutionAdd': '新增淨值方案',
  'menu.netValueSolution.netValueSolutionList': '淨值方案列表',
  'menu.netValueSolution.netValueSolutionCommonParams': '通用參數管理',
  'menu.netValueSolution.netValueSolutionPlanCustomParams': '自訂參數',
  'menu.netValueSolutionAdd': '新增淨值方案',
  'menu.netValueSolutionList': '淨值方案列表',
  'menu.netValueSolutionCommonParams': '通用參數管理',
  'menu.netValueSolutionPlanCustomParams': '自訂參數',

  // 完整的台賬管理子菜單路徑
  'menu.ledger.ledgerList': '台賬明細',
  'menu.ledgerList': '台賬明細',
  'menu.ledger.ledgerInquiry': '詢價台賬',
  'menu.ledgerInquiry': '詢價台賬',
  'menu.ledger.ledgerEdit': '編輯台賬',
  'menu.ledgerEdit': '編輯台賬',
};
